import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Col, Row } from 'reactstrap';
import ExternalLayout from "../../customComponents/ExternalLayout/ExternalLayout";
import RenderPage from "../../customComponents/RenderPage/RenderPage";
import Strip from "../../customComponents/Strip/Strip";
import { useWindowSize } from "@react-hook/window-size";
import SEOComponent from "../../customComponents/SEO/SEOComponent";
import application_contants from '../../contants/application_contants';
import './_Hack4ttsjury.scss';
import speakerData from './speaker_data.json'; // The processed JSON from your sheet

const Hack4ttsJury = (props) => {
  const [width] = useWindowSize();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const HackathonLayout = () => {
  const [rows, setRows] = useState([]);
  const [selectedSpeaker, setSelectedSpeaker] = useState('Speaker1');
  const [currentData, setCurrentData] = useState([]);
  const [blobUrls, setBlobUrls] = useState({});
  const [failedUrls, setFailedUrls] = useState(new Set());

  const teams = [
    { label: 'Baseline', key: 'Audio File of Baseline' },
    { label: 'Somya.ai', key: 'Audio File of Somya.ai' },
    { label: 'LTRC-SPL', key: 'Audio File of LTRC-SPL' },
    { label: 'CDAC-SVNIT', key: 'Audio File of CDAC-SVNIT' },
    { label: 'Immverse AI', key: 'Audio File of Immverse AI' }
  ];

  const speakerOptions = Array.from({ length: 10 }, (_, i) => `Speaker${i + 1}`);

  // 1. Disable keyboard shortcuts for developer tools
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (
        e.keyCode === 123 || // F12
        (e.ctrlKey && e.shiftKey && e.keyCode === 73) || // Ctrl+Shift+I
        (e.ctrlKey && e.shiftKey && e.keyCode === 74) || // Ctrl+Shift+J
        (e.ctrlKey && e.keyCode === 85) || // Ctrl+U
        (e.ctrlKey && e.shiftKey && e.keyCode === 67) // Ctrl+Shift+C
      ) {
        e.preventDefault();
        return false;
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  // 2. Load Speaker Data from JSON
  useEffect(() => {
    const speakerEntry = speakerData.find(s => s.speaker === selectedSpeaker);
    setCurrentData(speakerEntry ? speakerEntry.data : []);
    
    // Reset scroll position to show first column (mobile optimization)
    if (width <= application_contants.MOBILE_BREAKPOINT) {
      const tableContainer = document.querySelector('.table-mobile-container');
      if (tableContainer) {
        tableContainer.scrollLeft = 0;
      }
    }
  }, [selectedSpeaker, width]);

  // 3. Convert Proxy URLs to Blob URLs for obfuscation (prevents direct link copying)
  useEffect(() => {
    const fetchAndCreateBlobUrls = async () => {
      const newBlobUrls = {};
      const newFailedUrls = new Set();
      
      for (const row of currentData) {
        for (const team of teams) {
          let audioUrl = row[team.key];
          // Trim whitespace and carriage returns from the URL
          if (audioUrl) {
            audioUrl = audioUrl.trim();
          }
          // If audioUrl exists and we haven't created a blob for it yet
          if (audioUrl && !blobUrls[audioUrl] && !failedUrls.has(audioUrl)) {
            try {
              const response = await fetch(audioUrl); // Nginx handles the proxy
              if (!response.ok) {
                console.error(`Failed to fetch ${audioUrl}: ${response.status} ${response.statusText}`);
                newFailedUrls.add(audioUrl);
                continue;
              }
              const blob = await response.blob();
              newBlobUrls[audioUrl] = URL.createObjectURL(blob);
            } catch (error) {
              console.error(`Error loading audio blob for ${audioUrl}:`, error);
              newFailedUrls.add(audioUrl);
            }
          }
        }
      }
      setBlobUrls(prev => ({ ...prev, ...newBlobUrls }));
      setFailedUrls(prev => new Set([...prev, ...newFailedUrls]));
    };

    if (currentData.length > 0) {
      fetchAndCreateBlobUrls();
    }

    return () => {
      Object.values(blobUrls).forEach(url => URL.revokeObjectURL(url));
    };
  }, [currentData]);

  return (
    <ExternalLayout>
      <RenderPage
        id="tst-Hack4TTS"
        className={`render px-0 ${props.isClassName ? "render-page " : "min-height-auto"}`}
        containerType="container-fluid"
      >
        <SEOComponent
          title="Voice Tech for All"
          keywords="SYnthesizing SPeech in INdian languages"
          description="Speech recognition in agriculture and finance for the poor is an initiative predominantly to create resources and make them available as a digital public good"
          siteUrl="/Hack4TTS"
        />
          <Strip
              id="tst-strip-partners"
              className="strip strip-no-padding px-0"
              containerType="container"
          >
            <Row className="mx-0  pt-5">  
            {width <= application_contants.MOBILE_BREAKPOINT ? <h5 className="h5-medium section-title title-navy-blue jostRegular pb-4 align-left"> Evolution of Tools</h5> :
              <h5 className="h5-medium section-title jostRegular title-navy-blue align-left pt-5 pb-5 line-height-48px pl-3"> Jury App</h5>}
                <Col xs={12} sm={12} md={12} lg={12} xl={12} className="pb-4 pt-2">
                  <h1 className="evltl-h1">Web App for Jury</h1>
{/* <div>
    <p> Web app will come here</p>
</div>
<div className="dropdown-container" >
    <select id="sentenceDropdown" onChange={handleDropdownChange} value={selectedValue}>
      <option value="">Select Speaker</option>
      <option value="1">Speaker 1</option>
      <option value="2">Speaker 2</option>
      <option value="3">Speaker 3</option>
      <option value="4">Speaker 4</option>
      <option value="5">Speaker 5</option>
      <option value="6">Speaker 6</option>
      <option value="7">Speaker 7</option>
      <option value="8">Speaker 8</option>
      <option value="9">Speaker 9</option>
      <option value="10">Speaker 10</option>
    </select>
  </div> */}

 <div className="hackathon-container" >
      {/* Dropdown Selection */}
      <div className="header-section">
        <select 
          className="speaker-dropdown"
          value={selectedSpeaker}
          onChange={(e) => setSelectedSpeaker(e.target.value)}
        >
          {speakerOptions.map(opt => (
            <option key={opt} value={opt}>{opt}</option>
          ))}
        </select>
      </div>

      <div className={width <= application_contants.MOBILE_BREAKPOINT ? "table-mobile-container" : "table-container"}>
        <table className={width <= application_contants.MOBILE_BREAKPOINT ? "main-mobile-table" : "main-table"}>
          <thead>
            <tr>
              <th className="winner_box header">S. No.</th>
              <th className="winner_box header">Text/Sentences</th>
              {teams.map(team => (
                <th key={team.label} className="winner_box header team-col">
                  Audio File of <br/> {team.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentData.map((row, index) => (
              <tr key={row['Sentence / Text Id']}>
                <td className="winner_box cell">{index + 1}</td>
                <td className="winner_box cell text-content">
                  <div className="text-id">{row['Sentence / Text Id']}</div>
                  <div className="sentence-text">{row['Telugu sentences']}</div>
                </td>
                {teams.map(team => {
                  const originalUrl = row[team.key];
                  const sourceUrl = blobUrls[originalUrl] || originalUrl;
                  const isFailed = failedUrls.has(originalUrl);
                  
                  return (
                    <td key={team.key} className="winner_box cell">
                      {!originalUrl ? (
                        <span className="no-audio">N/A</span>
                      ) : isFailed ? (
                        <span className="no-audio" style={{ color: '#dc3545' }}>
                          File Not Found
                        </span>
                      ) : (
                        <audio 
                          controls 
                          className="audio-control"
                          controlsList="nodownload" // Disables the 3-dot download menu
                          onContextMenu={(e) => e.preventDefault()}
                        >
                          <source src={sourceUrl} type="audio/wav" />
                          Your browser does not support the audio element.
                        </audio>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
                    </Col>
                        
                    </Row>
                </Strip>
      </RenderPage>
    </ExternalLayout>
  );
};

Hack4ttsJury.defaultProps = { isClassName: true };
export default Hack4ttsJury;